const cacheTime = 10 * 60 * 1000

const tokenKey = process.env.TOKEN_KEY
const shopKey = 'shopInfo'
const userKey = 'userInfo'


const localStore = {
    getToken() {
        return localStorage.getItem(tokenKey)
    },
    setToken(token) {
        return localStorage.setItem(tokenKey, token)
    },
    removeToken() {
        return localStorage.removeItem(tokenKey)
    },
    getShop() {
        const shopInfo = localStorage.getItem(shopKey)
        if (shopInfo) {
            const shop = JSON.parse(shopInfo)
            const setTime = parseInt(shop['_set_time'])
            if (setTime && (setTime + cacheTime) > new Date().getTime()) {
                return shop
            } else {
                return null
            }
        } else {
            return null
        }
    },
    setShop(shop) {
        shop['_set_time'] = new Date().getTime()
        const shopInfo = JSON.stringify(shop)
        return localStorage.setItem(shopKey, shopInfo)
    },
    removeShop() {
        return localStorage.removeItem(shopKey)
    },
    getUser() {
        const userInfo = localStorage.getItem(userKey)
        if (userInfo) {
            const user = JSON.parse(userInfo)
            const setTime = parseInt(user['_set_time'])
            if (setTime && (setTime + cacheTime) > new Date().getTime()) {
                return user
            } else {
                return null
            }
        } else {
            return null
        }
    },
    setUser(user) {
        if (user) {
            user['_set_time'] = new Date().getTime()
            const userInfo = JSON.stringify(user)
            return localStorage.setItem(userKey, userInfo)
        }
    },
    removeUser() {
        return localStorage.removeItem(userKey)
    }
}

export default localStore



// WEBPACK FOOTER //
// ./src/utils/localStore.js